/** Returns true if currently in the browser. Typically used to keep browser-only code from running on the server
 * during SSR. */
export function isInBrowser() {
  return typeof window !== 'undefined';
}
